import { gql, useApolloClient } from "@apollo/client";
import { UpdateBusinessFragmentDoc, UpdateThemeFragmentDoc } from "../types";
gql `
fragment UpdateTheme on Theme {
  cornerRoundness
  badgeText1
  badgeText2
  badgeAlignment
  badgeInverted
  badgeFontSize
}`;
gql `
fragment UpdateBusiness on Business {
  id
  oneLiner
  mission
  enablePastCustomerUpsell
  enableEmailUpsell
  enableSmsUpsell
  enableRedirectUpsell
  enableTips
  enableProductSwapping
  enableAutomatedCuration
  enableFAQ
  enableBadge
  enableNavigationLink
  enableAddToCartUpsell
  enableSidebarUpsell
  includeWelcomeGiftInFirstShipment
}
`;
export const useUpdateThemeCache = (id, field) => {
    const client = useApolloClient();
    return (ev) => {
        if (!id)
            return;
        const theme = client.readFragment({
            id: `Theme:${id}`,
            fragment: UpdateThemeFragmentDoc,
            fragmentName: "UpdateTheme"
        });
        let fieldValue = ev.target.value;
        if (field === "cornerRoundness" || field === "badgeFontSize")
            fieldValue = parseInt(ev.target.value);
        else if (field === "badgeInverted" && ev.target instanceof HTMLInputElement)
            fieldValue = ev.target.checked;
        client.writeFragment({
            id: `Theme:${id}`,
            fragment: UpdateThemeFragmentDoc,
            fragmentName: "UpdateTheme",
            data: Object.assign(Object.assign({}, theme), { [field]: fieldValue })
        });
    };
};
export const useUpdateBusinessCache = (id, field) => {
    const client = useApolloClient();
    return (ev) => {
        const business = client.readFragment({
            id: `Business:${id}`,
            fragment: UpdateBusinessFragmentDoc,
            fragmentName: "UpdateBusiness"
        });
        // KGAUDIT - what else kind is there?
        if (ev.target.getAttribute("type") === "checkbox") {
            client.writeFragment({
                id: `Business:${id}`,
                fragment: UpdateBusinessFragmentDoc,
                fragmentName: "UpdateBusiness",
                data: Object.assign(Object.assign({}, business), { [field]: ev.target.checked })
            });
        }
    };
};
